import React from 'react';
import styled from 'styled-components';
import { Animation } from '..';
import animations from './animations';

type AnimationType = 'congratulations' | 'talk' | 'sleep' | 'idle';

interface Props {
  animation?: AnimationType;
  size?: number;
  play?: boolean;
}

const AnimationStyled = styled(Animation)<{ $size: number }>`
  position: absolute;
  width: ${(props) => props.$size}rem;
  display: block;
  height: auto;
  transform: rotate(5deg);
`;

const Whizzy = ({ animation, size = 60, play = true, ...rest }: Props): JSX.Element => {
  let path;
  switch (animation) {
    case 'congratulations':
      path = animations.PROFESSOR_CONGRATULATIONS[0].data;
      break;
    case 'talk':
      path = animations.PROFESSOR_TALK[0].data;
      break;
    case 'sleep':
      path = animations.PROFESSOR_SLEEP[0].data;
      break;
    default:
      path = animations.PROFESSOR_IDLE[0].data;
      break;
  }

  return (
    <AnimationStyled
      options={{
        loop: true,
        autoplay: play,
        prerender: true,
      }}
      isPlay={play}
      path={path}
      $size={size}
      {...rest}
    />
  );
};

Whizzy.displayName = 'Whizzy';
export default Whizzy;
